export default __webpack_public_path__ + "static/media/worthy.0730a900.svg";